import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import classnames from 'classnames'

import { useAuthState, useLayoutHeaderTransparency, useQuery } from 'hooks'
import { apiManager } from 'helpers'
import { ROUTES } from 'helpers/constants'

import { AuthModal, Button, IOSDownloadLink, ProfileImage, Spinner } from 'components'
import ProfileInfo from 'components/ProfileInfo'

import appStoreImg from 'assets/images/app-store-gray.png'
import logo from 'assets/images/logo-small.png'

const BTN_CLASS = 'w-full h-14 rounded-t-none'
const QUERY_STALE_TIME = 1000 * 60 * 30

const PublicProfile = ({ match }) => {
  const slug = match.params.slug
  useLayoutHeaderTransparency(true)
  const { user } = useAuthState()
  const [showAuthModal, setShowAuthModal] = useState(false)

  const {
    data: userProfile,
    isLoading,
    refetch,
  } = useQuery(['userProfile', slug], () => apiManager.getUserPublicProfile(slug), {
    staleTime: QUERY_STALE_TIME,
  })

  const handleShowAuthModal = () => setShowAuthModal(true)

  return (
    <div
      className={classnames('bg-black min-h-screen w-full text-white flex flex-col items-center', {
        'px-2.5 pt-24 md:pt-28': !user,
      })}
    >
      {!isLoading ? (
        userProfile ? (
          user ? (
            <div className="max-w-lg h-screen w-full bg-black relative md:pt-20 md:pb-5">
              <ProfileInfo
                user={userProfile.user}
                classes={{
                  container:
                    'pb-10 md:border md:border-solid md:border-gray-800 md:bg-black md:rounded-3xl',
                }}
                hostEvents={[]}
                applications={[]}
                refetch={refetch}
                showWaitlistStatus
              />
            </div>
          ) : (
            <div className="w-full max-w-xl">
              <div className="bg-woodsmokeBlack rounded-t-2xl p-5 mb-0.5">
                <div className="flex items-center">
                  <ProfileImage
                    className="w-20 h-20 rounded-full object-cover block mr-4"
                    src={userProfile.user.profileImage}
                  />
                  <div className="text-white flex-grow">
                    <div className="text-lg">
                      {userProfile.user.firstName || userProfile.user.name}
                    </div>
                    <div className="text-sm opacity-50">@{userProfile.user.username}</div>
                  </div>
                </div>
                {userProfile.user.profile?.bio && (
                  <div className="text-sm text-lightGray mt-4 break-words md:text-base">
                    {userProfile.user.profile.bio}
                  </div>
                )}
              </div>
              <Button
                className={classnames(
                  BTN_CLASS,
                  'bg-woodsmokeBlack text-base rounded-t-sm rounded-b-sm mb-1'
                )}
                onClick={handleShowAuthModal}
              >
                <span className="font-norm2al">View Full Profile</span>
              </Button>
            </div>
          )
        ) : (
          <div className="flex h-40 items-center text-xl">User profile not found 😔</div>
        )
      ) : (
        <div className="h-52 flex items-center">
          <Spinner />
        </div>
      )}
      {!user && (
        <div className="mt-14">
          <div className="mb-10 text-center text-base opacity-50">
            Want to view more people?
            <br />
            Get the app & see who wants to meet you!
          </div>
          <div className="w-full flex justify-center ">
            <Link to={ROUTES.LANDING}>
              <img
                className="h-14 mr-3.5"
                src={logo}
                alt="logo"
                style={{ filter: 'drop-shadow(0px 0px 14.884px rgba(255, 255, 255, 0.6))' }}
              />
            </Link>
            <IOSDownloadLink src={appStoreImg} />
          </div>
        </div>
      )}
      <AuthModal
        show={showAuthModal}
        onClose={() => setShowAuthModal(false)}
        onComplete={() => {
          refetch()
          setShowAuthModal(false)
        }}
      />
    </div>
  )
}

export default PublicProfile
